export default function Blog() {
  return (
    <div>
      <h1>Blog Page</h1>
    </div>
  );
}
